import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { workplaceListApiV1CollaborationAppWorkplaceGetQueryKey } from '../gen/base'

export const useInvalidateWorkplaceListQuery = () => {
    const queryClient = useQueryClient()

    return useCallback(() => {
        queryClient.invalidateQueries({
            predicate: (query) =>
                query.queryKey.some(
                    (key) =>
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-expect-error
                        key?.url ===
                        workplaceListApiV1CollaborationAppWorkplaceGetQueryKey()[0].url,
                ),
        })
    }, [queryClient])
}
